import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { MessagingScheduleView } from "@/features/developer/messaging-schedule/MessagingScheduleView";
import { useNav } from "@/utils/nav";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/features/messaging-schedule")({
    component: MessagingSchedulePage,
});

function MessagingSchedulePage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Messaging schedule", route: { to: "/design/features/messaging-schedule" } },
    ]);

    return (
        <AdminPageLayout
            title="Messaging schedule"
            description="Full visibility of Knock workflow messages and relative send times, derived from current workflow.json files and en-GB fixtures."
            headerActions={
                <Link to="/customers/success" className="text-sky-700 text-sm hover:underline underline-offset-2">
                    Live user activation
                </Link>
            }
        >
            <MessagingScheduleView />
        </AdminPageLayout>
    );
}
